import { call, put, select } from "redux-saga/effects";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";
import { selectDevice } from "../../../state/device/deviceSlice";
import { readConferenceParticipantsSaga } from "../readConferenceParticipants/readConferenceParticipants";
import cirrusClient from "../../../services/api/cirrus-client";


export function* endConferenceCallSessionSaga(action) {
    try {
        // Fetch user credentials from Redux store
        const { user } = yield select(selectUserCredentials);
        const { DeviceUser } = yield select(selectDevice);
        const conferenceDomain = 'netsapiens.com'
        const { conferenceUri } = action.payload;
        const participants = yield call(readConferenceParticipantsSaga, { payload: { conferenceUri } });
        console.log('These are the participants to remove', participants)
        // const apiUrl = '?object=participant&action=update'
        const apiUrl = '?object=participant&action=disc'

        // Disconnect participants
        for (const participant of participants) {
            if (participant.participant_match !== `sip:${DeviceUser}@${conferenceDomain}`) {
                // const params = {
                //     user,
                //     conference_match: conferenceUri,
                //     conference: conferenceUri,
                //     participant_match: participant.participant_match,
                //     participant: participant.participant_match,
                //     auto_dsc: '2',
                // };
                const params = {
                    conference_match: conferenceUri,
                    participant_match: participant.participant_match,
                };
                yield call(cirrusClient.post, apiUrl, params);
            }
        }

    } catch (error) {
        console.error('Error ending conference call session:', error);
    }


}